import { EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CostCalculationService } from '../../../Services/cost-calculation.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { CostCalculationVM } from '../../../Model/cost-calculation/CostCalculationVM';
import { DownloadService } from '../../../Services/download.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import { DtoListTotalPriceForClientVM } from '../../../Model/cost-calculation/DtoListTotalPriceForClientVM';
import { ClientsListComponent } from '../../clients/clients-list/clients-list.component';
import { DtoListCostCalcToClientVM } from '../../../Model/cost-calculation/DtoListCostCalcToClientVM';
import { AddOrderNameComponent } from '../add-order-name/add-order-name.component';
import { SendWhatsAppMessageComponent } from '../../../Shared/Components/send-whats-app-message/send-whats-app-message.component';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-display-price-for-client',
  templateUrl: './display-price-for-client.component.html',
  styleUrl: './display-price-for-client.component.scss'
})
export class DisplayPriceForClientComponent {
  @Input() DisplayPriceData: CostCalculationVM[] = [];
  @Input() SectorId: string | null = null;
  UpdateListCostCalcData: DtoListCostCalcToClientVM = {};
  DtoListTotalPriceData: DtoListTotalPriceForClientVM = {};
  @Output() IsDisplayPrice = new EventEmitter<boolean>();

  constructor(private api: CostCalculationService, private shared: SharedService, private download: DownloadService,
    private spinner: NgxSpinnerService, private auth: AuthService,
    private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.GetListTotalPriceForClient();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetListTotalPriceForClient() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      let data = {'sectorId': this.SectorId, 'products': this.DisplayPriceData};
      this.api.GetListTotalPriceForClient(data)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.UpdateListCostCalcData.costCalcIds = data.costCalcIds;
              this.DtoListTotalPriceData.costCalcIds = data.costCalcIds;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ClacNumberOfMeters(width?: any, height?: any): number {
    return this.shared.ClacNumberOfMeters(width, height);
  }

  GetCost(cost?: CostCalculationVM) {
    let TotalCost = cost?.width! * cost?.height! * cost?.price!;
    return TotalCost;
  }

  ClacTotalCost(cost?: CostCalculationVM, idAdditionalDetails?: boolean) {
    let TotalCost = cost?.width! * cost?.height! * cost?.price! * cost?.count!;
    if (idAdditionalDetails) return TotalCost + this.ClacAllAdditions();
    return TotalCost;
  }

  SaveDisplayPrice() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoSaveDisplayPrice',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        const dialogClientsList = this.dialogService.openDialog(ClientsListComponent);

        dialogClientsList.afterClosed().subscribe(result => {
          if (result) {
            this.UpdateListCostCalcData.clientId = result?.data
            const dialogAddOrder = this.dialogService.openDialog(AddOrderNameComponent);
            dialogAddOrder.afterClosed().subscribe(result => {
              if (result) {
                this.UpdateListCostCalcData.orderName = result?.data;
                this.UpdateListCostCalcToClient();
              }
            });
          }
        });
      }
    });

  }

  ClacAllAdditions() {
    let cost = 0;
    this.DisplayPriceData.forEach(item => {
      item.AdditionalDetails?.forEach(data => {
        cost += (data?.width ?? 0) * (data?.height ?? 0) * (data?.price ?? 0);
      });
    });

    return cost;
  }

  exportPDF() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.download.CostCalcsToPdf(this.DtoListTotalPriceData)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.shared.downloadBlobFile(data, 'CostCalcs');
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  UpdateListCostCalcToClient() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.api.UpdateListCostCalcToClient(this.UpdateListCostCalcData)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              if (data) {
                this.toastrService.showSuccessToast('Success', 'SavedSuccessfully');
                setTimeout(() => { this.IsDisplayPrice.emit(false); }, 600);
              }
              else {
                this.toastrService.showErrorToast('Error', data.message);
              }
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBackWithoutSave',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.IsDisplayPrice.emit(false);
      }
    });
  }



  SendWhatsAppMessage() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      // let url = this.download.CostCalcsToPdfUrl(this.DtoListTotalPriceData)
      // this.shared.SendWhatsAppMessage(url, true);
      this.download.CostCalcsToPdf(this.DtoListTotalPriceData)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              const blobUrl = URL.createObjectURL(data);
              this.shared.SendWhatsAppMessage(blobUrl, true);
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
